export function formatExpiry(expiresAt: string): string {
  const now = Date.now();
  const then = new Date(expiresAt).getTime();
  const diffMs = then - now;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMs < 0) {
    const pastDays = Math.abs(diffDays);
    if (pastDays === 0) return 'Expired today';
    return `Expired ${pastDays} day${pastDays === 1 ? '' : 's'} ago`;
  }
  if (diffDays === 0) return 'Expires today';
  if (diffDays === 1) return 'Expires tomorrow';
  return `Expires in ${diffDays} days`;
}
